var exports = {
  "YW": "Page__y0Vl3A",
  "wn": "Section__O6puYz",
  "mc": "Container__9q6AqC",
  "uA": "Component__STBg0X",
};

module.exports = exports;
